/* eslint-disable react/no-array-index-key */
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';
import React from 'react';
import { Right } from '../Right';

interface Props {
	onChange?: (values: string[]) => void;
	value?: string[];
	placeholder?: string;
	disabled?: boolean;
	loading?: boolean;
}

export const CustomArrayString: React.FC<Props> = ({ loading, placeholder, disabled, onChange, value }) => {
	const onChangeLocal = (index: number, newValue: string) => {
		const newValueArray = [...(value || [])];
		newValueArray[index] = newValue;
		onChange?.(newValueArray);
	};

	const onRemove = (index: number) => {
		const newValueArray = [...(value || [])];
		newValueArray.splice(index, 1);
		onChange?.(newValueArray);
	};

	const onAdd = () => {
		const newValueArray = [...(value || []), ''];
		onChange?.(newValueArray);
	};

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			{value?.map((v, index) => (
				<Space.Compact key={index} block>
					<Input
						placeholder={placeholder}
						value={v}
						onChange={e => onChangeLocal(index, e.target.value)}
						disabled={disabled || loading}
						size="large"
					/>
					<Button
						loading={loading}
						disabled={disabled}
						danger
						icon={<DeleteOutlined />}
						onClick={() => onRemove(index)}
						size="large"
					/>
				</Space.Compact>
			))}
			<Right>
				<Button loading={loading} disabled={disabled} icon={<PlusCircleOutlined />} onClick={() => onAdd()} />
			</Right>
		</Space>
	);
};
